type LoopLogoBadgeProps = {
  width?: number | string;
  height?: number | string;
  label?: string;
  className?: string;
};

export const LoopLogoBadge = ({
  width = 16,
  height = 16,
  label = 'Loop logo',
  className,
}: LoopLogoBadgeProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
    >
      <path
        d="M5.75439 15.5741C5.81508 15.5837 5.91759 15.593 6.02278 15.5914C6.16181 15.5891 6.21147 15.4402 6.14128 15.3204C6.05744 15.1774 5.98442 15.0242 5.92141 14.879C5.47491 13.8497 5.53985 12.4122 5.53985 11.3199L5.54029 9.29912C5.54044 8.71528 5.56677 8.22309 5.44004 7.64553C5.30942 7.04602 5.03904 6.48577 4.65062 6.01008C4.05825 5.28474 3.25432 4.83647 2.45487 4.37526C2.17283 4.21254 0.657043 3.36383 0.480421 3.28365C0.228372 3.16931 0.0942894 3.16694 0.0382369 3.32028C-0.00927864 3.44793 0.0110369 4.08134 0.0117856 4.31039L0.0119317 7.68817C0.0120778 8.26272 0.014333 8.75618 0.0651994 9.33073C0.112934 9.90966 0.225898 10.4814 0.401561 11.0353C0.861805 12.4592 1.89939 13.986 3.21586 14.7021C3.95342 15.1033 4.86982 15.4324 5.75439 15.5741Z"
        fill="currentColor"
      />
      <path
        d="M7.58321 21.8324H18.2832C18.8683 21.8324 18.7104 21.5882 18.6364 21.4603C18.582 21.3663 17.2203 19.0014 17.0172 18.6761C16.9266 18.5316 16.829 18.3918 16.7247 18.2569C15.6394 16.858 14.5297 16.9548 12.9298 16.9549L7.81528 16.9551C6.92947 16.9551 6.2145 16.9817 5.33306 16.8707C2.24464 16.3903 0.944971 15.1668 0.152538 12.5044C0.129027 12.4254 0.00611105 12.442 0.00579148 12.5244C-0.0015495 14.4058 -0.033963 15.4145 0.194995 16.7366C0.297696 17.3295 0.501426 17.9006 0.782867 18.4328C1.5847 19.9302 2.69884 21.0692 4.56345 21.5678C4.77634 21.6247 5.86851 21.8324 7.58321 21.8324Z"
        fill="currentColor"
      />
      <path
        d="M16.5387 6.24113C16.478 6.23147 16.3754 6.22219 16.2702 6.22382C16.1312 6.2261 16.0816 6.37497 16.1517 6.49479C16.2356 6.63783 16.3086 6.79099 16.3716 6.93622C16.8182 7.96551 16.7532 9.40298 16.7532 10.4953L16.7528 12.5161C16.7526 13.0999 16.7262 13.5921 16.853 14.1697C16.9836 14.7692 17.254 15.3294 17.6424 15.8051C18.2348 16.5305 19.0387 16.9787 19.8382 17.4399C20.1202 17.6027 21.636 18.4514 21.8126 18.5315C22.0647 18.6459 22.1987 18.6483 22.2548 18.4949C22.3024 18.3673 22.282 17.7339 22.2813 17.5048L22.2811 14.1269C22.281 13.5525 22.2787 13.059 22.2279 12.4845C22.1801 11.9055 22.0672 11.3338 21.8915 10.78C21.4312 9.35597 20.3936 7.82921 19.0772 7.11307C18.3396 6.7119 17.4233 6.38281 16.5387 6.24113Z"
        fill="currentColor"
      />
      <path
        d="M14.7136 9.11117e-06H4.0136C3.42843 9.11117e-06 3.58639 0.24428 3.66035 0.372109C3.71478 0.466136 5.07651 2.83112 5.27963 3.15639C5.3702 3.3008 5.46781 3.44066 5.57214 3.5755C6.65744 4.97442 7.76711 4.87767 9.36704 4.87758L14.4815 4.8774C15.3674 4.8774 16.0823 4.85079 16.9638 4.96185C20.0522 5.44219 21.3518 6.66564 22.1443 9.32801C22.1677 9.40701 22.2907 9.39042 22.291 9.30806C22.2984 7.4266 22.3308 6.418 22.1018 5.09588C21.9991 4.50292 21.7954 3.93183 21.5139 3.39965C20.7121 1.90223 19.5979 0.763243 17.7334 0.264679C17.5205 0.207735 16.4283 9.11117e-06 14.7136 9.11117e-06Z"
        fill="currentColor"
      />
    </svg>
  );
};
